import React from "react";
import { icon, label } from "../../config";
import { formatDate } from "../editor.helper";
import { Tooltip } from "@progress/kendo-react-tooltip";

/**
 * Displays detailed information about the task such as name, due date, priority, and assignee.
 *@author Muskan Thakur
 */
const TaskDetailsContent = ({ taskInfo, userInfo ,handleOpenSidebar, hashPopupVisible}) => {
  const { Name, DueDate, Priority, PriorityName, ProjectTaskId, IsTaskComplete, IsTaskClosed } = taskInfo;

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleOpenSidebar();
  };

  return (
    <>
      <div className='details-horizontal'>
        <div className='details-column  mb-2'>
           <div className='task-name-container flex-grow-1 task-name-wrapper d-flex w-100'>
            <Tooltip position='bottom' parentTitle={true}>
          {!!(IsTaskComplete || IsTaskClosed) && <div title='Closed' className='d-flex justify-content-center task-icon-container mr-2'>{ icon.CIRCLE_CHECK_GREEN }</div>}
          </Tooltip>
            {!!hashPopupVisible && !!handleOpenSidebar ? (
              <span
                className='task-details-id fw-bold mr-2 text-primary cursor-pointer task-details-id-link'
                role='button'
                tabIndex={0}
                onClick={handleOpenSidebar}
                onKeyDown={handleKeyDown}>
                {ProjectTaskId}
              </span>
            ) : (
              <span className='task-details-id fw-bold mr-2'>{ProjectTaskId}</span>
            )}
          <div className='text-wrap task-tile-content overflow-hidden mb-1'>{Name}</div>
        </div>
        </div>
      </div>

      <div className='details-horizontal'>
        <div className='details-column'>
          <label>{label.DUE_DATE}</label>
          <div>{formatDate(DueDate)}</div>
        </div>

        <div className='details-column'>
          <label>{label.PRIORITY}</label>
          <div className='task-content'>
            <div>{icon[Priority]}</div>
            <div>{PriorityName}</div>
          </div>
        </div>

        <div className='details-column'>
          <label>{label.ASSIGN_TO}</label>
          <div className='task-content'>
            {userInfo?.PhotoLinks?.small ? (
              <img className='object-fit-cover user-image  rounded-circle' src={userInfo?.PhotoLinks?.small} alt='user-image' />
            ) : (
              <div>{icon["ACCOUNT_CIRCLE"]}</div>
            )}
            <div>{userInfo?.label ?? label.UNASSIGNED}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(TaskDetailsContent);
